export const messages = {
  en: {
    machineTranslateManage: {
      search: {
        title: 'Search Conditions',
        typeCd: 'Select Object Type',
        selectType: 'Please select object type',
        objId: 'Please enter object ID',
        objName: 'Please enter object name'
      },
      list: {
        title: 'IoT Synchronization'
      },
      table: {
        objId: 'Object ID',
        typeCd: 'Object Type',
        objName: 'Object Name',
        machineCmd: 'Command',
        state: 'Status',
        remark: 'Remark',
        updateTime: 'Sync Time',
        operation: 'Operation'
      },
      button: {
        resync: 'Resync'
      },
      state: {
        notSync: 'Not Synced',
        synced: 'Synced'
      },
      type: {
        owner: 'Owner',
        community: 'Community',
        keyInfo: 'Key Info',
        visitorInfo: 'Visitor Info',
        staffFace: 'Staff Face',
        carInfo: 'Car Info',
        deviceInfo: 'Device Info'
      },
      add: {
        title: 'Add Device Sync',
        machineCode: 'Device Code',
        machineCodePlaceholder: 'Required, please enter device code',
        machineId: 'Device ID',
        machineIdPlaceholder: 'Required, please enter device ID',
        typeCd: 'Object Type',
        typeCdPlaceholder: 'Required, please select object type',
        objName: 'Object Name',
        objNamePlaceholder: 'Required, please enter object name',
        objId: 'Object ID',
        objIdPlaceholder: 'Required, please enter object ID',
        state: 'Status',
        statePlaceholder: 'Required, please select status'
      },
      edit: {
        title: 'Resync',
        machineCode: 'Device Code',
        machineId: 'Device ID',
        typeCd: 'Object Type',
        objName: 'Object Name',
        objId: 'Object ID'
      },
      validate: {
        machineCodeRequired: 'Device code cannot be empty',
        machineCodeMaxLength: 'Device code cannot exceed 30 characters',
        machineIdRequired: 'Device ID cannot be empty',
        typeCdRequired: 'Object type cannot be empty',
        objNameRequired: 'Object name cannot be empty',
        objIdRequired: 'Object ID cannot be empty',
        objIdNumber: 'Object ID must be a number',
        stateRequired: 'Status cannot be empty'
      },
      message: {
        addSuccess: 'Add success',
        resyncSuccess: 'Resync success',
        fetchError: 'Failed to fetch data'
      },
      fetchError: "Failed to fetch device data",
      page: {
        title: 'IoT Sync',
        subtitle: 'Monitor object-to-device command sync status and resync failures',
        empty: 'No sync records found'
      }
    }
  },
  zh: {
    machineTranslateManage: {
      search: {
        title: '查询条件',
        typeCd: '请选择对象类型',
        selectType: '请选择对象类型',
        objId: '请输入对象ID',
        objName: '请输入对象名称'
      },
      list: {
        title: '物联网同步'
      },
      table: {
        objId: '对象ID',
        typeCd: '对象类型',
        objName: '对象名称',
        machineCmd: '指令',
        state: '状态',
        remark: '说明',
        updateTime: '同步时间',
        operation: '操作'
      },
      button: {
        resync: '重新同步'
      },
      state: {
        notSync: '未同步',
        synced: '已同步'
      },
      type: {
        owner: '业主',
        community: '小区',
        keyInfo: '钥匙信息',
        visitorInfo: '访客信息',
        staffFace: '员工人脸',
        carInfo: '车辆信息',
        deviceInfo: '设备信息'
      },
      add: {
        title: '添加设备同步',
        machineCode: '设备编码',
        machineCodePlaceholder: '必填，请填写设备编码',
        machineId: '设备ID',
        machineIdPlaceholder: '必填，请填写设备ID',
        typeCd: '对象类型',
        typeCdPlaceholder: '必填，请选择对象类型',
        objName: '对象名称',
        objNamePlaceholder: '必填，请填写对象名称',
        objId: '对象ID',
        objIdPlaceholder: '必填，请填写对象ID',
        state: '状态',
        statePlaceholder: '必填，请选择状态'
      },
      edit: {
        title: '重新同步',
        machineCode: '设备编码',
        machineId: '设备ID',
        typeCd: '对象类型',
        objName: '对象名称',
        objId: '对象ID'
      },
      validate: {
        machineCodeRequired: '设备编码不能为空',
        machineCodeMaxLength: '设备编码不能超过30位',
        machineIdRequired: '设备ID不能为空',
        typeCdRequired: '对象类型不能为空',
        objNameRequired: '对象名称不能为空',
        objIdRequired: '对象ID不能为空',
        objIdNumber: '对象ID必须为数字',
        stateRequired: '状态不能为空'
      },
      message: {
        addSuccess: '添加成功',
        resyncSuccess: '重新同步成功',
        fetchError: '获取数据失败'
      },
      fetchError: "获取设备数据失败",
      page: {
        title: '物联网同步',
        subtitle: '监控对象指令下发状态并对失败记录重新同步',
        empty: '暂无同步记录'
      }
    }
  }
}